import React from 'react'
import NumberFormat from 'react-number-format'
import styled from 'styled-components'

const Container = styled.div`
  background: ${props => props.theme.colors.white};
  box-shadow: ${props => props.theme.boxShadow.greenLight};
  border-radius: ${props => props.theme.borderRadius.light};
  padding: 15px 20px;
`

const Number = styled.div`
  font-size: 14px;
`

export default ({ active, payload }) => (
  active && (
    <Container>
      <Number
        as={NumberFormat}
        value={payload[0].value}
        displayType='text'
        thousandSeparator
        prefix='$'
      />
    </Container>
  )
)
